import { CEOrganizationInviteAttributesBase } from './ce-organization-invite-attributes-base'


export class CEOrganizationInviteAttributes extends CEOrganizationInviteAttributesBase {

}